// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  getImageUrl,
} from '@vroskus/library-helpers/dist/browser';
import config from '../../../../config';

// Services
import Services from '../../../../services';

// Components
import Section from '../../../layout/Section';
import Loader from '../../../layout/Loader';

// Types
type $Props = $Translate & {
  item: $Model<'Championship'>;
};

type $State = {
  data: Array<$Model<'ChampionshipSponsor'>>;
  loading: boolean;
};

class SponsorsSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      data: [],
      loading: false,
    };
  }

  componentDidMount(): void {
    this.getData();
    this.setupSocket();
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getData(): Promise<void> {
    const {
      item,
    } = this.props;

    try {
      await this.setStateAsync({
        loading: true,
      });

      const data = await Services.Api.getChampionshipSponsorsSectionData({
        ChampionshipId: item.id,
      });

      await this.setStateAsync({
        data,
        loading: false,
      });
    } catch (error) {
      await this.setStateAsync({
        loading: false,
      });

      ErrorLog.exception(error as Error);
    }
  }

  setupSocket(): void {
    const {
      item,
    } = this.props;

    Services.Socket.on({
      action: (data) => {
        if (data.ChampionshipId === item.id && data.modelName === 'ChampionshipSponsor') {
          this.getData();
        }
      },
      type: Services.Socket.type.modelChangedEvent,
    });
  }

  render() {
    const {
      t,
    } = this.props;
    const {
      data,
      loading,
    } = this.state;

    return (data.length > 0 ? (
      <Section
        id={webSections[webPages.championshipPage].sponsors}
        noMargin
        transparent
      >
        <Loader
          fade
          loading={loading === true}
        >
          <div className={'grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 gap-3'}>
            {data.map((dataItem: $Model<'ChampionshipSponsor'>) => (
              <a
                className={'bg-white rounded-lg overflow-hidden text-center flex items-center'}
                href={dataItem.Link}
                key={dataItem.id}
                rel={'noreferrer'}
                target={'_blank'}
                title={dataItem.Name}
              >
                <img
                  alt={t('Sponsor')}
                  className={'max-h-32 mx-auto'}
                  src={getImageUrl({
                    cdnUrl: config.CDN_URL,
                    image: dataItem.Image,
                    size: 'max',
                  })}
                />
              </a>
            ))}
          </div>
        </Loader>
      </Section>
    ) : null);
  }
}

export default SponsorsSectionView;
